"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.websocketClockSync = void 0;
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _manager = _interopRequireDefault(require("../resources/websocket/manager"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var websocketClockSync = exports.websocketClockSync = function websocketClockSync(time) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ts';
  if ((0, _isNil.default)(time)) return time;
  var wsServerDelay = _manager.default.getServerDelay();
  var sync = new Date(time).getTime() + wsServerDelay;
  if (type.toLowerCase() === 'date') return new Date(sync);
  if (type.toLowerCase() === 'iso') return new Date(sync).toISOString();
  return sync;
};